import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import Filters from "../../Misc/Filters";
import List from "../../Misc/List";
import JournalAddModal from "./JournalAddModal";
import JournalTupleItem from "./JournalTupeItem";
export default class JournalItem extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.state = {
      pending: false,
      showModal: false,
      showFilters: false,

      item: [],
      fields: [],
      ships: [],

      filters: {
        show: false,
        active: [],
        default: [],
        all: [],
      },
      customListKey: "",
    };
  }

  componentDidMount() {
    this.load();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.nodeId !== this.props.nodeId ||
      prevProps.itemId !== this.props.itemId
    ) {
      this.load();
    }
  }

  makeFilters = async () => {
    let users = await this.context.api.qa("/user/list", {
      orderby: ["name ASC"],
    });
    let usersVariants = [];
    users.forEach((item) =>
      usersVariants.push([
        item.name,
        [{ field: "userid", compare: "EQL", value: item.id }],
      ])
    );

    this.setState({
      pending: false,
      filters: {
        active: [],
        default: [
          {
            lstr: "(",
            field: "journal",
            compare: "EQL",
            value: this.props.itemId,
            rstr: ")",
          },
        ],
        all: [
          {
            id: "timestamp",
            title: "По дате",
            kind: "range",
            timestamp: true,
            active: false,
            value: [],
          },
          {
            id: "userid",
            title: "Пользователь",
            kind: "dropdown",
            multiple: true,
            active: false,
            activeVariants: [],
            variants: usersVariants,
          },
        ],
      },
    });
  };

  getFields = async (filter) => {
    let fields = [];
    //Construct fileds
    let firstFields = await this.context.api.qa("/form/field/list", {
      filter,
      orderby: ["sequence ASC"],
    });

    let allFormsIDs = firstFields.reduce((v, f) => {
      let id = f.type === "subform" ? f.value : f.form;
      return !id || v.includes(id) ? v : [...v, id];
    }, []);

    let allFields = await this.context.api.qa("/form/field/list", {
      search: [
        {
          field: "form",
          valarr: allFormsIDs,
        },
      ],
      orderby: ["sequence ASC"],
    });

    firstFields.forEach((f) => {
      if (f.type === "subform") {
        f.subform = allFields.filter((sf) => sf.form === f.value);
      }
      fields.push(f);
    });
    return fields;
  };

  load = async () => {
    const { itemId } = this.props;
    this.setState({ pending: true });

    let item = {};
    let fields = [];
    let ships = [];

    if (itemId) {
      item = await this.context.api.q("/journal/get", {
        id: itemId,
      });

      fields = await this.getFields({ form: item.form });

      if (item.area) {
        ships = await this.context.api.q("/ship/list", {
          filter: {
            area: item.area,
          },
        });
      }
    }

    this.setState({ item, fields, ships }, () => this.makeFilters());
  };

  save = async (formData) => {
    const { itemId } = this.props;
    this.onModalHide();
    this.setState({ pending: true });
    let result = await this.context.api.q("/journal/tuple/set", {
      journal: itemId,
      tuple: formData,
    });
    if (!result) {
      this.context.toast("Не удалось сохранить запись", "error");
      this.setState({ pending: false });
    } else {
      this.setState({ recoffset: 0, customListKey: this.context.key() }, () =>
        this.load()
      );
    }
  };

  onModalShow = () => {
    this.setState({ showModal: true });
  };

  onModalHide = () => {
    this.setState({ showModal: false });
  };

  filtersToggle = () => {
    this.setState((state) => {
      return {
        showFilters: !state.showFilters,
      };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };

  render() {
    const {
      pending,
      showModal,
      fields,
      ships,
      filters,
      showFilters,
    } = this.state;
    let item = this.state.item || {};
    let ship = null;

    const tableHeadings = (
      <thead>
        <tr>
          <th></th>
          {fields.map((item, idx) => {
            let field = item || {};
            return <th key={idx}>{field.label}</th>;
          })}
        </tr>
      </thead>
    );

    if (ships.length) {
      ship = ships[0];
    }

    return (
      <>
        <JournalAddModal
          fields={fields}
          show={showModal}
          onHide={this.onModalHide}
          onSave={this.save}
        />
        <Blocker spinnerFixed hAuto on={pending}>
          {item.id && (
            <>
              <div className="card p-3 d-flex flex-row justify-content-between  ">
                <div>
                  <h6>{item.label}</h6>
                  {item.description && (
                    <div className="text-muted small">{item.description}</div>
                  )}
                  <div>
                    {ship && (
                      <>
                        {ship.label && (
                          <span className="text-dark-75 small mr-2">
                            {ship.label}
                          </span>
                        )}
                        {ship.code && (
                          <span className="text-dark-50 small mr-2">
                            IMO: {ship.code}
                          </span>
                        )}
                        {ship.callsign && (
                          <span className="text-dark-50 small mr-2">
                            {ship.callsign}
                          </span>
                        )}
                        {ship.contractorname && (
                          <span className="text-dark-50 small mr-2">
                            {ship.contractorname}
                          </span>
                        )}
                      </>
                    )}
                    {item.areaname && !ship && (
                      <span className="text-dark-50 small">
                        {item.areaname}
                      </span>
                    )}
                  </div>
                </div>
                <div>
                  <button
                    onClick={this.filtersToggle}
                    className={`btn btn-icon mr-2 ${
                      showFilters ? "btn-light-primary" : "btn-light"
                    }`}
                    title="Фильтры"
                  >
                    <i className="fa fa-filter"></i>
                  </button>
                  <button
                    onClick={this.onModalShow}
                    className="btn btn-icon btn-light"
                    title="Добавить запись"
                  >
                    <i className="flaticon2-add-1"></i>
                  </button>
                </div>
              </div>
              {showFilters && (
                <div className="card p-3 mt-2">
                  <Filters
                    changeFn={this.handleFilters}
                    filters={this.state.filters.all}
                  />
                </div>
              )}
            </>
          )}
          <div className="table-responsive">
            <table className="table">
              {filters.default.length > 0 && (
                <List
                  limit={150}
                  listKey="tupleList"
                  key={this.state.customListKey}
                  search={JSON.stringify(
                    this.state.filters.active.concat(this.state.filters.default)
                  )}
                  sort={JSON.stringify(["timestamp DESC"])}
                  hideSinglePageNav={true}
                  keyField="id"
                  path="/journal/tuple/list"
                  blocker={{ spinnerFixed: true, hAuto: true }}
                >
                  <JournalTupleItem fields={fields} />
                </List>
              )}
            </table>
          </div>
        </Blocker>
      </>
    );
  }
}
